import common from './common';
import navigate from './navigate';

export default {
  首页: '首页',
  我的: '我的',
  消息: '消息',
  市场: '市场',
  动态: '动态',
  代发车: '代发车',
  工作台: '工作台',
  找货: '找货',

  ...navigate,
  ...common,
};
